import { now, createDate } from '@/lib/dateUtils.js'

export default {
  methods: {
    notBeforeToday (date) {
      return date < now()
    },
    notNightTime (date) {
      return date.getHours() < 7 || date.getHours() > 22
    },
    notNightReservationTime (date) {
      const baseDate = createDate(date)
      return date.getHours() < 7 || baseDate?.isAfter(baseDate?.format('YYYY-MM-DDT21:00'), 'minute')
    }
  },
  computed: {
    defaultValueInDaytime () {
      return createDate('0800', 'HHmm')
    }
  }
}
